var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "additional-layers-control",
        on: {
          click: function ($event) {
            $event.preventDefault()
            _vm.showLayers = !_vm.showLayers
          },
        },
      },
      [
        _c("span", [_vm._v("Additional Activity Data")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.showHideText))]),
      ]
    ),
    _vm._v(" "),
    _vm.showLayers
      ? _c(
          "div",
          { staticClass: "additional-layers-container" },
          _vm._l(_vm.additionalActivityLayers, function (layer) {
            return _c("div", [
              layer.legend_below_title && layer.mparc_legend
                ? _c("div", { staticClass: "legend-item-with-title" }, [
                    _c("div", [
                      _c("label", [
                        layer.allow_control
                          ? _c("input", {
                              staticClass: "legend-checkbox",
                              attrs: { type: "checkbox", id: layer.layer_name },
                              domProps: { checked: layer.layer_enabled },
                              on: {
                                change: function ($event) {
                                  return _vm.toggleActivityLayer(
                                    $event,
                                    layer.layer_name
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                            " +
                            _vm._s(layer.layer_name_display) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { display: "none" },
                        attrs: { id: "lg" + layer.layer_name },
                      },
                      _vm._l(
                        layer.mparc_legend.legendItems,
                        function (legendItem) {
                          return _c(
                            "div",
                            { staticClass: "json-legend-below-title" },
                            [
                              _c("div", [
                                _c("div", {
                                  staticClass:
                                    "base-custom-leaflet-legend-style",
                                  style: legendItem.style,
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(legendItem.category_name)),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !layer.legend_below_title
                ? _c("div", { staticClass: "basic-legend-item" }, [
                    _c("div", [
                      layer.allow_control
                        ? _c("input", {
                            staticClass: "legend-checkbox",
                            attrs: { type: "checkbox", id: layer.layer_name },
                            domProps: { checked: layer.layer_enabled },
                            on: {
                              change: function ($event) {
                                return _vm.toggleActivityLayer(
                                  $event,
                                  layer.layer_name
                                )
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      !layer.leaflet_styles
                        ? _c("img", {
                            attrs: { src: layer.legend_graphic, alt: "" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      layer.leaflet_styles
                        ? _c("div", [
                            _c("div", {
                              staticClass: "base-custom-leaflet-legend-style",
                              style: layer.leaflet_legend_styles,
                            }),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("label", { attrs: { for: layer.layer_name } }, [
                        _vm._v(_vm._s(layer.layer_name_display)),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              layer.legend_below_title && !layer.mparc_legend
                ? _c("div", { staticClass: "legend-item-with-title" }, [
                    _c("div", [
                      _c("label", [
                        layer.allow_control
                          ? _c("input", {
                              staticClass: "legend-checkbox",
                              attrs: { type: "checkbox", id: layer.layer_name },
                              domProps: { checked: layer.layer_enabled },
                              on: {
                                change: function ($event) {
                                  return _vm.toggleActivityLayer(
                                    $event,
                                    layer.layer_name
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                            " +
                            _vm._s(layer.layer_name_display) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "legend-item-below-title",
                        staticStyle: { display: "none" },
                        attrs: { id: "lg" + layer.layer_name },
                      },
                      [
                        _c("div", [
                          _c("img", {
                            attrs: { src: layer.legend_graphic, alt: "" },
                          }),
                        ]),
                        _vm._v(" "),
                        layer.legend_additional_text
                          ? _c("div", {
                              staticStyle: { "line-height": "normal" },
                              domProps: {
                                innerHTML: _vm._s(layer.legend_additional_text),
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }